export function CallWindowSizeIcon({ compact }: { compact: boolean }) {
  return (
    <span className={`call-window-size-icon${compact ? ' call-window-size-icon-expand' : ''}`} aria-hidden="true" />
  )
}
